import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";
import { getUrl } from "../../lib/masterUtil";
import { Link } from "../../lib/Link";
import { Route, Switch, NavLink } from "react-router-dom";

export const beginner_movie = (type, tabId) => {
  console.log(tabId)
  document.title =
    "トランクルームをお探しなら『ハローストレージ』【公式】｜収納動画";
  return (
    <div className="container">
      {breadcrumbs(type, [
        { href: "/beginner/", text: "初めての方へ" },
        { text: "収納動画" },
      ])}
      <div className="beginner_contents_detail beginner_movie">
        <div className="main">
          <div className="content_wrap">
            <div className="content_wrap_inner">
              <div className="content_box">
                <h2 className="content_title">収納動画</h2>
                <div className="text_box">
                  <p>
                    収納スペースのサイズを選ぶことで、どのくらいの量の荷物が収納できるのか、動画で見ることができます。
                    さらに「同じ広さのトランクルームを探す」ボタンから収納スペースを直接探すこともできます。
                  </p>
                </div>
              </div>
              <div className="tab_wrap">
                <div className="tabHeader">
                  <NavLink
                    to={{ pathname: "/beginner/movie/0_5", state: { linkType: 'tab' } }}
                    activeClassName="active"
                    className="tabHeaderItem type_0_5"
                    isActive={() => !tabId || tabId === '0_5'}
                  >
                    <strong>0.5</strong>帖<br/>タイプ
                  </NavLink>
                  <NavLink
                    to={{ pathname: "/beginner/movie/1", state: { linkType: 'tab' } }}
                    activeClassName="active"
                    className="tabHeaderItem type_1"
                  >
                    <strong>1</strong>帖<br/>タイプ
                  </NavLink>
                  <NavLink
                    to={{ pathname: "/beginner/movie/2", state: { linkType: 'tab' } }}
                    activeClassName="active"
                    className="tabHeaderItem type_2"
                  >
                    <strong>2</strong>帖<br/>タイプ
                  </NavLink>
                  <NavLink
                    to={{ pathname: "/beginner/movie/4", state: { linkType: 'tab' } }}
                    activeClassName="active"
                    className="tabHeaderItem type_4"
                  >
                    <strong>4</strong>帖<br/>タイプ
                  </NavLink>
                  <NavLink
                    to={{ pathname: "/beginner/movie/8", state: { linkType: 'tab' } }}
                    activeClassName="active"
                    className="tabHeaderItem type_8"
                  >
                    <strong>8</strong>帖<br/>タイプ
                  </NavLink>
                </div>
                <div className="tabContent">
                  <Switch>
                    <Route
                      exact
                      path="/beginner/movie/1"
                      render={props => (
                        <div>
                          <video
                            src="resource/video/1.mp4"
                            poster="resource/img/static/beginner/movie/poster_1.png"
                            autoplay
                            controls
                          />
                          <div className="description_box">
                            <div className="cf">
                              <div className="description_inner">
                                <h3 className="description_title">
                                  <strong>1</strong>帖タイプの収納目安
                                  <span>（約 120cm×135cm×220cm）</span>
                                </h3>
                                <p className="description_text">
                                  段ボール×３ ／ 大きめの買い物袋×１ ／ 冬用コート×３ ／ 麦わら帽子×２ ／
                                  くつ×７ ／ 大きめのタンス×１ ／ トートバック×２ ／ 物干し台×１ ／
                                  小さめのキャリーケース×１ ／ 手提げかばん×１ ／ 大きめの箱×２ ／ 棚×２ ／ 収納かご×１
                                </p>
                              </div>
                              <div className="btn_area">
                                <Link
                                  className="btn"
                                  to={getUrl({ condition: { extent: 2 } })}
                                >同じ広さのトランクルームを探す</Link>
                              </div>
                            </div>
                            <h3 className="description_title point"><span>おすすめポイント</span></h3>
                            <p className="description_text">
                              1人暮らし用のもう１つのクローゼットとして最適なサイズ。<br/>
                              1年分の洋服や靴・鞄を季節ごとに入れ替え、
                              お部屋もクローゼットも余裕のある、快適生活にしませんか。
                            </p>
                          </div>
                        </div>
                      )}
                    />
                    <Route
                      exact
                      path="/beginner/movie/2"
                      render={props => (
                        <div>
                          <video
                            src="resource/video/2.mp4"
                            poster="resource/img/static/beginner/movie/poster_2.png"
                            autoplay
                            controls
                          />
                          <div className="description_box">
                            <div className="cf">
                              <div className="description_inner">
                                <h3 className="description_title">
                                  <strong>2</strong>帖タイプの収納目安
                                  <span>（約 145cm×230cm×220cm）</span>
                                </h3>
                                <p className="description_text">
                                  観葉植物×１ ／ 台×１ ／ スノーボード×１ ／ 手提げかばん×２ ／ 大きめの収納箱×１ ／
                                  壁掛け×１ ／ ランプ×１ ／ 工具箱×２ ／ レンジ×１ ／ フライパン×１ ／
                                  なべ×２ ／ ポット×２ ／ 冷蔵庫×１ ／ 傘立て×１ ／ 傘×１ ／ 段ボール×６ ／
                                  いす×１ ／ 大きめの椅子×１ ／ 物入れ×５ ／ マットレス×１ ／ ラック×１ ／ 収納棚×２ ／
                                  置き鏡×１ ／ 収納箱×５
                                </p>
                              </div>
                              <div className="btn_area">
                                <Link
                                  className="btn"
                                  to={getUrl({ condition: { extent: 3 } })}
                                >同じ広さのトランクルームを探す</Link>
                              </div>
                            </div>
                            <h3 className="description_title point"><span>おすすめポイント</span></h3>
                            <p className="description_text">
                              留学、海外出張など1人暮らしで必要な荷物をまるっと預ける時に最適なサイズ。<br/>
                              お部屋を借り続けるより、お荷物をトランクルームへ預けると節約に。<br/>
                              お荷物を安心して預け、戻られたら引っ越し先へ搬入という賢い使い方がオススメです。
                            </p>
                          </div>
                        </div>
                      )}
                    />
                    <Route
                      exact
                      path="/beginner/movie/4"
                      render={props => (
                        <div>
                          <video
                            src="resource/video/4.mp4"
                            poster="resource/img/static/beginner/movie/poster_4.png"
                            autoplay
                            controls
                          />
                          <div className="description_box">
                            <div className="cf">
                              <div className="description_inner">
                                <h3 className="description_title">
                                  <strong>4</strong>帖タイプの収納目安
                                  <span>（約 310cm×210cm×220cm）</span>
                                </h3>
                                <p className="description_text">
                                  食器棚×１ ／ クリスマスツリー×１ ／ 電子ピアノ×１ ／ 薄型テレビ×１ ／ ゴルフバック×１ ／
                                  スタンドライト×１ ／ タイヤ×４ ／ 箱×１ ／ 収納箱×６ ／ 本棚×１ ／ 縦長ステレオ×２ ／
                                  収納棚×１ ／ ベビーベッド×１ ／ 椅子×２ ／ テレビ台×１ ／ 楽器入れ×１ ／
                                  クローゼット×１ ／ テーブル×１ ／ ソファ×１ ／ 地球儀×１ ／ 段ボール×３ ／ 本×４０冊
                                </p>
                              </div>
                              <div className="btn_area">
                                <Link
                                  className="btn"
                                  to={getUrl({ condition: { extent: 4 } })}
                                >同じ広さのトランクルームを探す</Link>
                              </div>
                            </div>
                            <h3 className="description_title point"><span>おすすめポイント</span></h3>
                            <p className="description_text">
                              家族みんなの衣類・季節用品・家具など、大型収納に最適なサイズ。<br/>
                              ライフステージ、季節に合わせた荷物の出し入れに活躍する大きさで、
                              ファミリーの方に人気があるタイプです。
                            </p>
                          </div>
                        </div>
                      )}
                    />
                    <Route
                      exact
                      path="/beginner/movie/8"
                      render={props => (
                        <div>
                          <video
                            src="resource/video/8.mp4"
                            poster="resource/img/static/beginner/movie/poster_8.png"
                            autoplay
                            controls
                          />
                          <div className="description_box">
                            <div className="cf">
                              <div className="description_inner">
                                <h3 className="description_title">
                                  <strong>8</strong>帖タイプの収納目安
                                  <span>（約 230cm×590cm×220cm）</span>
                                </h3>
                                <p className="description_text">
                                  収納ロッカー×３ ／ 瓶ケース×２ ／ 台×１ ／ 工具入れ×４ ／ キャリーバック×２ ／ 縦長ステレオ×２ ／
                                  大きめの工具入れ×５ ／ ポスター×２ ／ デッキ×１ ／ 工具×１ ／ 持ち運び電源×１ ／
                                  パイプ椅子×２ ／ 延長コード×１ ／ 移動可能棚×１ ／ 収納箱×８ ／ 脚立×１ ／
                                  バイオリン×１ ／ テレビ×１ ／ 段ボール×２７ ／ 椅子×１ ／ 事務所デスク×２ ／
                                  大きな収納棚×３ ／ 書類収納棚×２
                                </p>
                              </div>
                              <div className="btn_area">
                                <Link
                                  className="btn"
                                  to={getUrl({ condition: { extent: 6 } })}
                                >同じ広さのトランクルームを探す</Link>
                              </div>
                            </div>
                            <h3 className="description_title point"><span>おすすめポイント</span></h3>
                            <p className="description_text">
                              会社の在庫備品・機材・ファイルなどを収納する倉庫として最適なサイズ。<br/>
                              店舗またはオフィスの倉庫として利用される法人様が多く、
                              屋外型では車の横付けが可能なので、
                              長めの物や大きな荷物も出し入れしやすく好評です。
                            </p>
                          </div>
                        </div>
                      )}
                    />
                    {/* デフォルトの要素 */}
                    <Route
                      render={props => (
                        <div>
                          <video
                            src="resource/video/0.5.mp4"
                            poster="resource/img/static/beginner/movie/poster_0.5.png"
                            autoplay
                            controls
                          />
                          <div className="description_box">
                            <div className="cf">
                              <div className="description_inner">
                                <h3 className="description_title">
                                  <strong>0.5</strong>帖タイプの収納目安
                                  <span>（約 90cm×90cm×220cm)</span>
                                </h3>
                                <p className="description_text">
                                収納棚×２ ／
                                  段ボール×３ ／
                                  ステレオ×２ ／
                                  収納カゴ×２ ／
                                  くつ×１ ／
                                  マイク×１ ／
                                  つりざお×１ ／
                                  本×３２冊 ／
                                  雑誌×２ ／
                                  小物入れ×１ ／
                                  ヘッドフォン×１ ／
                                  レコード盤×５ ／
                                  レコードプレーヤー×１ ／
                                  ギター×１ ／
                                  音響機器×１ ／
                                  椅子×１ ／
                                  ダーツ盤×１ ／
                                  ポスター×１
                                </p>
                              </div>
                              <div className="btn_area">
                                <Link
                                  className="btn"
                                  to={getUrl({ condition: { extent: 1 } })}
                                >同じ広さのトランクルームを探す</Link>
                              </div>
                            </div>
                            <h3 className="description_title point"><span>おすすめポイント</span></h3>
                            <p className="description_text">
                              自分専用の趣味ルームとして使うのに最適なサイズ。<br/>
                              ルーム内にコレクションを並べて自分だけの空間に。<br/>
                              お部屋を広く使いたい、オシャレな空間を崩したくない方などの、
                              もう１つの納戸としても、お気軽にご利用いただけます。
                            </p>
                          </div>
                        </div>
                      )}
                    />
                  </Switch>
                </div>
              </div>
            </div>
          </div>

          <div id="width">
            <div className="information">
              <div className="pc">
                <Link className="textArea" to="/lineup/">
                  <img src="resource/img/static/beginner/lineup.png" />
                  <span>
                    商品ラインナップは
                    <br />
                    こちら
                  </span>
                </Link>
                <Link className="textArea" to="/flow/">
                  <img src="resource/img/static/beginner/flow.png" />
                  <span>
                    お申し込みから
                    <br />
                    ご契約の流れまで
                  </span>
                </Link>
                <Link className="textArea" to="/voice2/">
                  <img src="resource/img/static/beginner/voice.png" />
                  <span>
                    実際の
                    <br />
                    お客様の声
                  </span>
                </Link>
              </div>
              <div className="sp">
                <Link className="text1" to="/lineup/">
                  <img src="resource/img/static/beginner/lineup_sp.png" />
                  <span>
                    商品ラインナップは
                    <br />
                    こちら
                  </span>
                </Link>
                <Link className="text2" to="/flow/">
                  <img src="resource/img/static/beginner/flow_sp.png" />
                  <span>
                    お申し込みから
                    <br />
                    ご契約の流れまで
                  </span>
                </Link>
                <Link className="text3" to="/voice2/">
                  <img src="resource/img/static/beginner/voice_sp.png" />
                  <span>
                    実際の
                    <br />
                    お客様の声
                  </span>
                </Link>
              </div>
              <br className="left" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/new/beginner_movie.jsx